import type { AccountDetail } from '../../../api/accounts'
import { formatRelative } from '../../../lib/format'

const LINK_LABEL: Record<string, string> = { app_transaction: 'App Store account', icloud_user: 'iCloud user (hint)' }

/** The devices bound to the account and the identities that find it. */
export function DevicesCard({ detail }: { detail: AccountDetail }) {
	const identities = [
		...detail.links.map((l) => ({ ...l, verified: true })),
		...detail.hints.map((h) => ({ ...h, verified: false })),
	]
	const liveTokens = detail.tokens.filter((t) => !t.revokedAt)
	return (
		<section className="card stack">
			<h2 style={{ margin: 0 }}>Devices</h2>
			{detail.devices.length ? (
				detail.devices.map((d, i) => (
					<div key={i} className="small">
						<strong>{d.name ?? 'Unnamed device'}</strong>{' '}
						<span className="muted">
							· {d.platform}
							{d.appVersion && ` · ${d.appVersion}`} · seen {formatRelative(d.lastSeenAt)}
						</span>
					</div>
				))
			) : (
				<p className="muted small" style={{ margin: 0 }}>
					No device has signed in yet.
				</p>
			)}
			<div className="stack" style={{ gap: '0.2rem' }}>
				{liveTokens.length ? (
					liveTokens.map((t) => (
						<div key={t.prefix} className="small">
							<span className="mono">{t.prefix}…</span> {t.deviceName ?? ''}
							<span className="muted">
								{t.appBuild !== null
									? ` · ${t.appVersion} (${t.appBuild}) on ${t.platform}, checked in ${formatRelative(t.checkedInAt)}`
									: ' · hasn’t checked in'}
							</span>
						</div>
					))
				) : (
					<div className="small muted">No live tokens.</div>
				)}
			</div>
			{identities.length > 0 && (
				<div className="stack" style={{ gap: '0.2rem' }}>
					{identities.map((l) => (
						<div key={`${l.kind}:${l.value}`} className="small">
							{LINK_LABEL[l.kind] ?? l.kind}: <span className="mono">{l.value}</span>
							{!l.verified && <span className="muted"> (unverified)</span>}
						</div>
					))}
				</div>
			)}
		</section>
	)
}
